export default __webpack_public_path__ + "static/media/Google2 - Logo.6f7b7b87.png";